import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-wrapper" }
const _hoisted_2 = { class: "app-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Appfooter = _resolveComponent("Appfooter")!
  const _component_LeitnerAddWordFab = _resolveComponent("LeitnerAddWordFab")!
  const _component_WelcomeOnboardingDialog = _resolveComponent("WelcomeOnboardingDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.$route.meta.hideHeaderFooter)
      ? (_openBlock(), _createBlock(_component_Header, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_router_view)
    ]),
    (!_ctx.$route.meta.hideHeaderFooter)
      ? (_openBlock(), _createBlock(_component_Appfooter, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_component_LeitnerAddWordFab),
    _createVNode(_component_WelcomeOnboardingDialog)
  ]))
}